module.exports = __webpack_public_path__ + "static/mk-business-rewards-card-d3de6f4fe98a9eed3ef2c234e8416409.png";